// extracted by mini-css-extract-plugin
export default {"container":"style_container__+brzu","text":"style_text__J4Dqd","tag":"style_tag__oyEVg","button_icon_keywords":"style_button_icon_keywords__XpOHs"};